import { QuestionField } from './QuestionField';
import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";
import type { QuestionTypeData } from "./QuestionTypeEditor";

export function WordLimitField({
  value,
  onChange,
}: {
  value?: number | null;
  onChange: (value: number | null) => void;
}) {
  const { t } = useTranslation();
  return (
    <label className="block space-y-1 text-sm">
      <span>{t("reading_max_words")}</span>
      <QuestionField name="maxWords"><Input
        type="number"
        min={1}
        max={1000}
        step={1}
        value={value ?? ""}
        placeholder={t("reading_no_limit")}
        onChange={(event) =>
          onChange(event.target.value ? Number(event.target.value) : null)
        }
        className="max-w-40"
      /></QuestionField>
    </label>
  );
}

export function ShortAnswerFields({
  data,
  correctAnswer,
  onChange,
}: {
  data: QuestionTypeData;
  correctAnswer?: unknown;
  onChange: (patch: Partial<QuestionTypeData>, answer?: string) => void;
}) {
  const { t } = useTranslation();
  const answers =
    data.acceptedAnswers ??
    (typeof correctAnswer === "string" && correctAnswer ? [correctAnswer] : []);
  return (
    <div className="space-y-3">
      <label className="block space-y-1.5 text-sm">
        <span>{t("reading_grading")}</span>
        <QuestionField name="answerMode">
          <Select
            value={data.answerMode ?? "manual"}
            onValueChange={(next) =>
              onChange({ answerMode: next as "exact" | "manual" })
            }
          >
            <SelectTrigger className="min-h-11 w-full bg-background text-sm">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="exact">{t("reading_exact")}</SelectItem>
              <SelectItem value="manual">{t("reading_manual")}</SelectItem>
            </SelectContent>
          </Select>
        </QuestionField>
      </label>
      <label className="block space-y-1 text-sm">
        <span>{t("reading_accepted_answers")}</span>
        <QuestionField name="acceptedAnswers"><textarea
          rows={3}
          className="w-full rounded-md border border-input bg-background px-3 py-2"
          value={answers.join("\n")}
          onChange={(event) => {
            const next = event.target.value.split("\n");
            onChange({ acceptedAnswers: next }, next[0] ?? "");
          }}
        /></QuestionField>
        <span className="block text-xs text-muted-foreground">
          {t("reading_answers_hint")}
        </span>
      </label>
      <WordLimitField
        value={data.maxWords}
        onChange={(maxWords) => onChange({ maxWords })}
      />
    </div>
  );
}
